(function(angular) {
    'use strict';
    angular.module('wtUi.wtSuiteContainer', ['wtUi.wtMenu', 'wtUi.wtTopNav', 'pascalprecht.translate'])
        .config(moduleConfig)
        .constant('PRODUCT', {
            AN: 'q3v2',
            URM: 'urm',
            MA: 'mac',
            TI: 'st'
        });
    moduleConfig.$inject = ['$translateProvider', '$translatePartialLoaderProvider'];
    function moduleConfig($translateProvider, $translatePartialLoaderProvider) { // eslint-disable-line id-length
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{part}/{lang}.json'
        });
        $translateProvider.useLoaderCache('$templateCache');
        $translatePartialLoaderProvider.addPart('wt-ui/suite-container/top-nav');
    }
})(window.angular);

